import { defineMessages } from 'react-intl';

const messages = defineMessages({
  recordTitle: {
    id: 'App.ManageProspects.CreateActivityModal.RecordTitle',
    defaultMessage: 'Record Activity',
  },
  scheduleTitle: {
    id: 'App.ManageProspects.CreateActivityModal.ScheduleTitle',
    defaultMessage: 'Schedule Activity',
  },
  createTitle: {
    id: 'App.ManageProspects.CreateActivityModal.CreateTitle',
    defaultMessage: 'Create Activity',
  },
  activityTypeLabel: {
    id: 'App.ManageProspects.CreateActivityModal.ActivityTypeLabel',
    defaultMessage: 'Select a type of activity',
  },
  activityCompletionLabel: {
    id: 'App.ManageProspects.CreateActivityModal.ActivityCompletionLabel',
    defaultMessage: 'How was this activity completed?',
  },
  activityDateLabel: {
    id: 'App.ManageProspects.CreateActivityModal.ActivityDateLabel',
    defaultMessage: 'Activity date',
  },
  recordTimeLabel: {
    id: 'App.ManageProspects.CreateActivityModal.RecordTimeLabel',
    defaultMessage: 'time',
  },
  scheduleStartTimeLabel: {
    id: 'App.ManageProspects.CreateActivityModal.ScheduleStartTimeLabel',
    defaultMessage: 'Start time',
  },
  scheduleEndTimeLabel: {
    id: 'App.ManageProspects.CreateActivityModal.ScheduleEndTimeLabel',
    defaultMessage: 'End time',
  },
  scheduleByLabel: {
    id: 'App.ManageProspects.CreateActivityModal.ScheduleByLabel',
    defaultMessage: 'Scheduled for',
  },
  notesLabel: {
    id: 'App.ManageProspects.CreateActivityChangeStatusModal.NotesLabel',
    defaultMessage: 'Notes',
  },
  notesPlaceholder: {
    id: 'App.ManageProspects.CreateActivityChangeStatusModal.NotesPlaceHolder',
    defaultMessage: 'Start typing...',
  },
  noTimeLabel: {
    id: 'App.ManageProspects.CreateActivityChangeStatusModal.NoTimeLabel',
    defaultMessage: 'Do not specify a time',
  },
  notesLengthWarning: {
    id: 'App.ManageProspects.CreateActivityChangeStatusModal.WotesLengthWarning',
    defaultMessage: '{current} of {max} max length.',
  },
  addActivity: {
    id: 'App.ManageProspects.CreateActivityModal.AddActivity',
    defaultMessage: 'Add Activity',
  },
  cancel: {
    id: 'App.ManageProspects.CreateActivityModal.Cancel',
    defaultMessage: 'Cancel',
  },
  notesRequired: {
    id: 'App.ManageProspects.CreateActivityModal.NotesRequired',
    defaultMessage: 'Notes are required',
  },
  requiredFields: {
    id: 'App.ManageProspects.CreateActivityModal.RequiredFields',
    defaultMessage: 'Required',
  },
  invalidTime: {
    id: 'App.ManageProspects.CreateActivityModal.InvalidTime',
    defaultMessage: 'Invalid time value',
  },
  invalidDate: {
    id: 'App.ManageProspects.CreateActivityModal.InvalidDate',
    defaultMessage: 'Invalid date value',
  },
  noOverlappingActivities: {
    id: 'App.ManageProspects.CreateActivityModal.NoOverlappingActivities',
    defaultMessage:
      'Activity timeframe conflicts with an activity already scheduled, please review activity date and time.',
  },
  tooManyActivitiesForAssignee: {
    id: 'App.ManageProspects.CreateActivityModal.TooManyActivitiesForAssignee',
    defaultMessage:
      'User cannot have more than 200 activities scheduled. Please complete some activities to continue.',
  },
  tooManyActivitiesForProspect: {
    id: 'App.ManageProspects.CreateActivityModal.TooManyActivitiesProspect',
    defaultMessage:
      'Prospect cannot have more than 5 activities scheduled. Please complete some activities to continue.',
  },
  noStartDateInFuture: {
    id: 'App.ManageProspects.CreateActivityModal.NoStartDateInFuture',
    defaultMessage:
      'You cannot add an activity record in the future, please review activity date and time.',
  },
  noStartDateInPast: {
    id: 'App.ManageProspects.CreateActivityModal.NoStartDateInPast',
    defaultMessage:
      'You cannot schedule a follow-up in the past, please review activity date and time.',
  },
  noEndDateBeforeStartDate: {
    id: 'App.ManageProspects.CreateActivityModal.NoEndDateBeforeStartDate',
    defaultMessage:
      'Start time needs to be before end time. Please review date and time.',
  },
  activityDetails: {
    id: 'App.ManageProspects.CreateActivityModal.ActivityDetails',
    defaultMessage: 'Activity Details',
  },
  schedulingDetails: {
    id: 'App.ManageProspects.CreateActivityModal.SchedulingDetails',
    defaultMessage: 'Scheduling Details',
  },
  allFieldsRequired: {
    id: 'App.ManageProspects.CreateActivityModal.AllFieldsRequired',
    defaultMessage: '*All fields are required',
  },
  prospect: {
    id: 'App.ManageProspects.CreateActivityModal.Prospect',
    defaultMessage: 'Prospect',
  },
  applicant: {
    id: 'App.ManageProspects.CreateActivityModal.Applicant',
    defaultMessage: 'Applicant',
  },
  resident: {
    id: 'App.ManageProspects.CreateActivityModal.Resident',
    defaultMessage: 'Resident',
  },
  'prior-resident': {
    id: 'App.ManageProspects.CreateActivityModal.PriorResident',
    defaultMessage: 'Prior Resident',
  },
  viewProfileButton: {
    id: 'App.ManageProspects.CreateActivityModal.ViewProfileButton',
    defaultMessage: 'View Profile',
  },
  chooseOption: {
    id: 'App.ManageProspects.CreateActivityModal.chooseOption',
    defaultMessage: 'Choose an option',
  },
  emptyAssignessListError: {
    id: 'App.ManageProspects.CreateActivityModal.EmptyAssignessListError',
    defaultMessage:
      '*There are no assignees. Please contact your system administrator.',
  },
  tooFarPast: {
    id: 'App.ManageProspects.CreateActivityModal.tooFarPast',
    defaultMessage:
      'You cannot record an activity before the prospect was created.',
  },
  calendarFor: {
    id: 'App.ManageProspects.CreateActivityModal.calendarfor',
    defaultMessage: 'Calendar for',
  },
  footerNote: {
    id: 'App.ManageProspects.CreateActivityModal.footerNote',
    defaultMessage:
      'Note: The user who saves the activity record will be listed as the ' +
      '"Completed By" user, regardless of who the activity was scheduled for.',
  },
});

export default messages;
